import { connect } from 'react-redux';
import { ActionViewModel } from 'stageclip-common/build/view-models/action-view-model';

import { ActionLogContent } from './ActionLogContent';
import { createModalOpenAction } from 'actions/modalActions';
import { SimpleModalId } from 'constants/modalId';

const mapDispatchToProps = (dispatch: any) => ({
  openDetails: (data: Pick<ActionViewModel, 'data' | 'action' | 'timestamp'>) =>
    dispatch(createModalOpenAction(SimpleModalId.LogDetails, data)),
});

export const ActionLogContentContainer = connect(null, mapDispatchToProps)(ActionLogContent);
